import { useQuery } from '@tanstack/react-query';

import { TEmployerId } from '@entities/modal/model/types/employerId';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

import { getEmployeeAccesses } from '../../api';
import { IEmployeeAccesses } from '../../model/types';

export const useGetEmployeeAccesses = (id: TEmployerId) => {
    const {
        isLoading: isGetEmployeeAccessesLoading,
        isFetching,
        data,
        isSuccess,
    } = useQuery<IDataResponse<IEmployeeAccesses>, Error>({
        queryKey: ['employeeAccesses', id],
        queryFn: () => getEmployeeAccesses(id),
        enabled: !!id,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        gcTime: 1000 * 60 * 5,
    });

    const employeeAccessData: IEmployeeAccesses = data?.data;

    return { isGetEmployeeAccessesLoading, isFetching, isSuccess, employeeAccessData };
};
